import { $myFetch } from "."

export interface IReferenceIsgUrl {
  url: string
  idSocieteg: number
}

export const $getReferenceIsgUrls = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    `referenceIsgUrl/GetReferenceIsgUrl`,
    {
      headers: myHeaders,
    },
    []
  )
}
